import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "range-input__input-group" };
const _hoisted_2 = ["id", "disabled", "required"];
const _hoisted_3 = { class: "range-input__divider" };
const _hoisted_4 = ["disabled", "required"];
import { ref } from "vue";
import { isValidTimeRange } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlRangeTime',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlRangeTime');
        const model = useFieldModel(() => props.data
            ? { from: props.data.from, to: props.data.to }
            : { from: '00:00', to: '00:00' });
        const invalid = ref(false);
        function onChange() {
            invalid.value = !isValidTimeRange(model.value);
            if (!invalid.value) {
                emitChange({ ...model.value });
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form__control range-input", { 'form__control--invalid': invalid.value }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(model).from) = $event)),
                        id: __props.fieldId,
                        disabled: _unref(fieldOptions).disabled ?? undefined,
                        required: _unref(fieldOptions).required ?? undefined,
                        step: "60",
                        type: "time",
                        class: "range-input__input",
                        placeholder: "00:00",
                        onChange: onChange,
                        onFocus: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                        onBlur: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_unref(onBlur) && _unref(onBlur)(...args)))
                    }, null, 40, _hoisted_2), [
                        [_vModelText, _unref(model).from]
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('range.to')), 1),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(model).to) = $event)),
                        disabled: _unref(fieldOptions).disabled ?? undefined,
                        required: _unref(fieldOptions).required ?? undefined,
                        min: "00:00",
                        max: "24:00",
                        step: "60",
                        type: "time",
                        class: "range-input__input",
                        placeholder: "00:00",
                        onChange: onChange,
                        onFocus: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                        onBlur: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => (_unref(onBlur) && _unref(onBlur)(...args)))
                    }, null, 40, _hoisted_4), [
                        [_vModelText, _unref(model).to]
                    ])
                ])
            ], 2));
        };
    }
});
